<template>
  <div class="crud_form_wrapper app_settings_class">
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: #233076" class="font-weight-bold">
          {{ $t("SIDENAV.settings.general") }}
        </h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: #233076">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="logo"
            :preSelectedImage="data.logo.path"
            :placeholder="$t('PLACEHOLDERS.image')"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload Input -->

          <!-- VAT Rate -->
          <!-- <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.vat_rate')"
            v-model.trim="data.tax"
            step="0.01"
            min="0"
            max="100"
          /> -->

          <!-- App Commission Rate -->
          <base-input
            type="number"
            col="6"
            :placeholder="
              $t('PLACEHOLDERS.rep_location_verification_range_in_meters')
            "
            v-model.trim="data.rep_location_verification_range_in_meters"
          />

          <!-- Spotify Link -->
          <base-input
            type="text"
            col="6"
            :placeholder="$t('PLACEHOLDERS.spotify')"
            v-model.trim="data.spotify"
          />

          <!-- Site URL -->
          <base-input
            type="text"
            col="6"
            :placeholder="$t('PLACEHOLDERS.site_url')"
            v-model.trim="data.site_url"
          />

          <!-- SEO Header Code -->
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.seo_header_code')"
            v-model="data.seo_header_code"
          />

          <!-- Google Tag Manager ID -->
          <base-input
            type="text"
            col="6"
            :placeholder="$t('PLACEHOLDERS.google_tag_manager_id')"
            v-model.trim="data.google_tag_manager_id"
          />

          <!-- Tag Manager Head Code -->
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.tag_manager_head_code')"
            v-model="data.tag_manager_head_code"
          />

          <!-- Tag Manager Body Code -->
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.tag_manager_body_code')"
            v-model="data.tag_manager_body_code"
          />

          <!-- Robots.txt -->
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.robots_txt')"
            v-model="data.robots_txt"
          />

          <!-- Sitemap XML -->
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.sitemap_xml')"
            v-model="data.sitemap_xml"
          />

          <!-- Sitemap URLs -->
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.sitemap_urls')"
            v-model="data.sitemap_urls"
          />

          <!-- Cancellation Time Limit (Hours) -->
          <!-- <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.driver_order_percentage')"
            v-model.trim="data.driver_order_percentage"
            min="0"
          /> -->

          <!-- <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.cancellation_time_limit_hours')"
            v-model.trim="data.cancellation_time_limit_hours"
            min="0"
          /> -->

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSetting",
  data() {
    return {
      isWaitingRequest: false,
      data: {
        logo: {
          file: null,
          path: null,
        },
        tax: null,
        price_per_km: null,
        driver_order_percentage: null,

        package_tax_percentage: null,
        documentation_amount: null,
        financial_liability_ratio: null,
        verified_financial_liability_ratio: null,
        spotify: null,
        seo_header_code: null,
        google_tag_manager_id: null,
        tag_manager_head_code: null,
        tag_manager_body_code: null,
        robots_txt: null,
        sitemap_xml: null,
        sitemap_urls: null,
        site_url: null,
      },
    };
  },
  methods: {
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.logo = selectedImage;
    },
    // End:: Select Upload Image

    async getDataToEdit() {
      try {
        let res = await this.$axios.get("settings?key=general-settings");
        console.log("bnn", res.data.data.data[0].value);
        const settings = res.data.data.data[0].value;

        // Map the response data to component data
        this.data.logo.path = settings?.logo;
        this.data.rep_location_verification_range_in_meters = Number(
          settings.rep_location_verification_range_in_meters
        );
        this.data.spotify = settings?.spotify || null;
        this.data.seo_header_code = settings?.seo_header_code || null;
        this.data.google_tag_manager_id =
          settings?.google_tag_manager_id || null;
        this.data.tag_manager_head_code =
          settings?.tag_manager_head_code || null;
        this.data.tag_manager_body_code =
          settings?.tag_manager_body_code || null;
        this.data.robots_txt = settings?.robots_txt || null;
        this.data.sitemap_xml = settings?.sitemap_xml || null;
        this.data.sitemap_urls = settings?.sitemap_urls || null;
        this.data.site_url = settings?.site_url || null;
        // this.data.driver_order_percentage = settings.driver_order_percentage;
      } catch (error) {
        console.error(error.response.data.message);
      }
    },
    async submitForm() {
      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("key", "general-settings");

      // Append all form data
      REQUEST_DATA.append(
        "value[logo]",
        this.data.logo.file ?? this.data.logo.path
      );
      REQUEST_DATA.append(
        "value[rep_location_verification_range_in_meters]",
        this.data.rep_location_verification_range_in_meters
      );
      REQUEST_DATA.append("value[spotify]", this.data.spotify || "");
      REQUEST_DATA.append(
        "value[seo_header_code]",
        this.data.seo_header_code || ""
      );
      REQUEST_DATA.append(
        "value[google_tag_manager_id]",
        this.data.google_tag_manager_id || ""
      );
      REQUEST_DATA.append(
        "value[tag_manager_head_code]",
        this.data.tag_manager_head_code || ""
      );
      REQUEST_DATA.append(
        "value[tag_manager_body_code]",
        this.data.tag_manager_body_code || ""
      );
      REQUEST_DATA.append("value[robots_txt]", this.data.robots_txt || "");
      REQUEST_DATA.append("value[sitemap_xml]", this.data.sitemap_xml || "");
      REQUEST_DATA.append("value[sitemap_urls]", this.data.sitemap_urls || "");
      REQUEST_DATA.append("value[site_url]", this.data.site_url || "");
      // REQUEST_DATA.append(
      //   "value[financial_liability_ratio]",
      //   this.data.financial_liability_ratio
      // );
      // REQUEST_DATA.append(
      //   "value[driver_order_percentage]",
      //   this.data.driver_order_percentage
      // );

      try {
        await this.$axios.post("settings?key=general-settings", REQUEST_DATA);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    validateFormInputs() {
      this.submitForm();
    },
  },
  created() {
    this.getDataToEdit();
  },
};
</script>
